import { EventTypeCategory } from "@graylog/enterprise-api";
export default function getEventTypeCategories() {
  return EventTypeCategory.getEventTypeCategoryUiMap();
}
